var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"center"},[_vm._v("ESTUDIANTES")]),_c('h3',{staticClass:"center"},[_vm._v("Personalización")]),_c('v-container',{},[_c('div')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }